// import hooks
import { useTranslation } from "react-i18next";
import { useState, useRef } from "react";

// import components
import ReCAPTCHA from "react-google-recaptcha";
import CustomPhoneInput from "../UI/CustomPhoneInput";

// import assets
import { whiteCart } from "../../utils/cards-svgs";

// import data

const { REACT_APP_RECAPTCHA_SITE_KEY } = process.env;
const AccountForm = () => {
    const [t] = useTranslation("global");
    const captchaRef = useRef(null);
    const [phone, setPhone] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        // const token = captchaRef.current.getValue();
        // console.log(token)
        captchaRef.current.reset();
        // props.mode.openVerify();
    };
    const changePhone = (e) => {
        setPhone(e);
    };
    return (
        <div className="account-form product-section-div">
            <form
                className="custom-modal-form signup-form"
                onSubmit={(e) => handleSubmit(e)}
            >
                <div className="label-input-div sign-up-form-field">
                    <label className="custom-modal-label">
                        {t("modals.signup.name")}
                    </label>
                    <input
                        type="text"
                        className="custom-modal-input ocean-input"
                        placeholder={t("modals.signup.name")}
                    />
                </div>
                <div className="sign-up-form-field">
                    <CustomPhoneInput
                        phone={phone}
                        onHandleChange={changePhone}
                    />
                </div>

                <div className="label-input-div sign-up-form-field">
                    <label className="custom-modal-label">
                        {t("modals.signup.email")}
                    </label>
                    <input
                        type="text"
                        className="custom-modal-input ocean-input"
                        placeholder={t("modals.signup.email")}
                    />
                </div>

                <p className="custom-modal-error login-error">Error field</p>
                {/* <div className="recaptcha-div">
                    <ReCAPTCHA
                        sitekey={REACT_APP_RECAPTCHA_SITE_KEY}
                        ref={captchaRef}
                        // theme={props.mode.mode}
                    />
                </div>

                <button type="submit" className="ocean-btn">
                    <img src={whiteCart} alt="icon" />
                    <span>{t("modals.signup.btn")}</span>
                </button> */}
            </form>

            <p className="ocean-p-grey">{t("cart.login")}</p>
        </div>
    );
};

export default AccountForm;
